module.exports = __webpack_public_path__ + "img/viscri32.1d05eea6.png";